import LayoutContainer from "../../container/layout";

const LayoutPage = () => {
    return <LayoutContainer />;
};

export default LayoutPage;
